import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent {

    constructor(private routerActivate: ActivatedRoute, private route: Router) {

    }
  
    goTo() {
      this.route.navigate([`/user/orders`]);
    }
}
